const Menopause = Object.freeze({
    PREMENOPAUSE: 'Premenopause',
    PERIMENOPAUSE: 'Perimenopause',
    POSTMENOPAUSE: 'Postmenopause',
    HYSTERECTOMY: 'Hysterectomy'
})

export default Menopause